import * as React from "react";
import * as moment from "moment";
import { observer } from "mobx-react";
import { AppStore } from "../../stores/AppStore";
import { observable } from "mobx";
import { Alert, Alignment, Button, Classes, Dialog, FormGroup, Tab, Tabs, Tag } from "@blueprintjs/core";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import { IEmpresa, newEmpresa } from "../../model";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { Pager } from "../utils/Pager";
import { toast } from "react-toastify";
import SolicitaSitfisPage from "./SolicitaSitfis";
import { SitfisStore } from "../../stores/sitfis/SitifisStore"
import { EmpresaSelect, filterEmpresa, renderEmpresa } from "../empresa/EmpresaSelect";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { formatCnpj, sortBy } from "../../utils";
import { getTag } from "../utils/getStatus";
import LoadingModal from "../loading/LoadingModal";


@observer
export default class SitfisPage extends React.Component<{}, {}> {

    obs = observable({
        tarefas_page: 1 as number,
        selectEmpresa: newEmpresa() as IEmpresa,
        erros: "" as string,
        view_erros: false as boolean
    })

    constructor(props: any) {
        super(props);
    }

    async componentDidMount() {
        AppStore.setTitle("Situação Fiscal (RFB)");
        SitfisStore.handleConsultaCredito()
    }

    handleBuscaTarefasPaged = async (page: number) => {
        this.obs.tarefas_page = page
        SitfisStore.obs.loading_solicitacoes = true
        SitfisStore.handleTasksPaged(page, this.obs.selectEmpresa.cnpj);
    };

    handleBuscaTarefas = async (empresa) => {
        this.obs.selectEmpresa = empresa
        SitfisStore.obs.loading_solicitacoes = true
        SitfisStore.handleTasksPaged(1, this.obs.selectEmpresa.cnpj);
    };

    onCloseErros() {
        this.obs.view_erros = false
        this.obs.erros = ""
    }

    async handleChangeTab(tabId: string) {
        await SitfisStore.handleConsultaCredito()
        SitfisStore.obs.selectedTab = tabId
    }

    handleAtualizaTarefasPaged = async () => {
        if (this.obs.selectEmpresa.cnpj == "") {
            toast.warning('Selecione uma empresa!', {});
            return;
        }
        SitfisStore.obs.loading_solicitacoes = true
        await SitfisStore.handleTasksPaged(this.obs.tarefas_page, this.obs.selectEmpresa.cnpj);
    };

    render() {
        function statusFormatter(cell, row) {

          return getTag(row.status, "sitfis");

        }

        function geradoFormatter(cell, row) {
            switch (row.automatico) {
                case true:
                    return <span className="new-tag-nav-new">Automático</span>
                default:
                    return <span className="new-tag-nav">Manual</span>
            }
        }

        function dateFormatter(cell, row) {
          
          if(cell){

            return moment(cell).add(3, "hour").format("DD/MM/YYYY") + " às " + moment(cell).add(3, "hour").format("HH:mm");
            
          }

          return moment(row.inserted_at).add(3, "hour").format("DD/MM/YYYY") + " às " + moment(row.inserted_at).add(3, "hour").format("HH:mm");

        };

        let empresaText = this.obs.selectEmpresa.cnpj != ""
            ? `${this.obs.selectEmpresa.razao_social.substring(0, 38)}... (${formatCnpj(this.obs.selectEmpresa.cnpj)})`
            : "Selecione uma empresa";

        function buttonFormaterDetalhes(cell, row) {
            return (
                <>
                    <MDBBtn
                        disabled={!row._id}
                        color="default"
                        rounded
                        size="sm"
                        onClick={(e) => handleViewDetalhes(row)}
                    >
                        <img src="/images/view.png" width="18px" />
                    </MDBBtn>
                    <MDBBtn
                        disabled={!row._id}
                        color="default"
                        rounded
                        size="sm"
                        onClick={(e) => handleViewArquivos(row)}
                    >
                        <img src="/images/download.svg" width="18px" />
                    </MDBBtn>
                </>
            );
        }


        const handleViewDetalhes = async (row: any) => {
            this.obs.erros = row.error

            if (this.obs.erros != "" && this.obs.erros != null) {
                this.obs.view_erros = true
            } else {
                toast.warn("Nenhum erro encontrado!", {});
                return
            }
        };

        const handleViewArquivos = async (row: any) => {

          await SitfisStore.downloadArquivos(row.sitfis_id, row.cnpj);

        };

        function statusJulgamento(cell, row) {
          switch (row.status_julgamento) {
              case "1":
                  return <Tag className="tagConfirmacao tagDownload" style={{ width: "70%", textAlign: "center" }}>Nenhuma Pendência</Tag>
              case "2":
                  return <Tag className="tagConfirmacao tagDownload tagNao" style={{ width: "70%", textAlign: "center" }}>Pendências</Tag>
              case "3":
                  return <Tag className="tagConfirmacao tagDownload tagSuspenso" style={{ width: "70%", textAlign: "center" }}>Suspenso</Tag>
              case "4":
                  return <Tag className="tagConfirmacao tagDownload tagCancelado" style={{ width: "70%", textAlign: "center" }}>Erro leitura do Arquivo</Tag>
              default:
                  return <></>
          }
      }

        return (
            <>
                <Tabs
                    id="tabs"
                    className={"tabsCalculos"}
                    selectedTabId={SitfisStore.obs.selectedTab}
                    onChange={(tabId) => this.handleChangeTab(String(tabId))}
                >
                    <Tab
                        id="downloads"
                        title="Downloads"
                        panel={<>
                            <MDBRow>
                                <MDBCol md="4">
                                        <FormGroup className="empresaSelect" label="Empresa">
                                            <EmpresaSelect
                                                items={EmpresaStore.sortedEmpresas.filter(x => x["filial"] == false)}
                                                itemRenderer={renderEmpresa}
                                                itemPredicate={filterEmpresa}
                                                onItemSelect={(e: IEmpresa) => this.handleBuscaTarefas(e)}
                                                inputProps={{ placeholder: "Filtrar uma empresa" }}
                                            >
                                                <Button
                                                    text={empresaText}
                                                    rightIcon="double-caret-vertical"
                                                    alignText={Alignment.LEFT} />
                                            </EmpresaSelect>
                                        </FormGroup>
                                </MDBCol>
                                <MDBCol md="2">
                                    <MDBBtn
                                        className="btnDefault btnBuscarNfe mt25"
                                        onClick={() => this.handleAtualizaTarefasPaged()}
                                    >
                                        Atualizar
                                    </MDBBtn>
                                </MDBCol>
                            </MDBRow>
                            <div>
                                <BootstrapTable className="TableDefault" ref="table" data={sortBy(SitfisStore.obs.tasks_sitfis, "inserted_at").reverse()}>
                                    <TableHeaderColumn dataField="_id" isKey={true} hidden width="1%">#</TableHeaderColumn>
                                    <TableHeaderColumn dataFormat={dateFormatter} dataField="inserted_at" width="20%">Data Solicitação</TableHeaderColumn>
                                    <TableHeaderColumn dataFormat={dateFormatter} dataField="_modifiedTS" width="20%">Ultima Atualização</TableHeaderColumn>
                                    <TableHeaderColumn dataFormat={geradoFormatter} width="20%">Origem</TableHeaderColumn>
                                    <TableHeaderColumn dataFormat={statusJulgamento} width="30%">Status Julgamento</TableHeaderColumn>
                                    <TableHeaderColumn dataFormat={statusFormatter} width="30%">Status</TableHeaderColumn>
                                    <TableHeaderColumn dataFormat={buttonFormaterDetalhes} width="20%">Detalhes</TableHeaderColumn>
                                </BootstrapTable>
                            </div>

                            <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>                                
                                  <Pager
                                    currentPage={this.obs.tarefas_page}
                                    totalCount={SitfisStore.obs.tasks_length}
                                    pageSize={15}
                                    onPageChange={page => this.handleBuscaTarefasPaged(page)} />
                            </div>
                        </>} />

                    <Tab
                        id="solicitacoes"
                        title="Solicitação"
                        panel={<SolicitaSitfisPage />} />
                </Tabs>

                <Alert
                    confirmButtonText="Fechar"
                    isOpen={this.obs.view_erros}
                    onConfirm={() => this.onCloseErros()}
                    onClose={() => this.onCloseErros()}
                    canOutsideClickCancel={true}
                    className="AlertUser"
                    intent="primary"
                >
                    <h3 className="titleProccess titleCnae">Logs Erros</h3>
                    <br />
                    <p>{this.obs.erros}</p>
                </Alert>

                <LoadingModal open={SitfisStore.obs.loading_arquivos} onClose={() => SitfisStore.obs.loading_arquivos = false} title={"Baixando arquivo"} />
                <LoadingModal open={SitfisStore.obs.loading_solicitacoes} onClose={() => SitfisStore.obs.loading_solicitacoes = false} title={"Buscando solicitações"} />

            </>
        )
    }
}

